var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.loadingOverlay},[_c('div',{class:_vm.$style.spinnerHolder},[_c('AppSpinner')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }